import { Result } from '@/main/models/common/resultResponse';
import { AxiosResponse } from 'axios';
import { DemoInfoPublicRequest } from '@/main/models/request/demoInfoPublicRequest';
import { IHomePagePublicApi } from '../base/public/IHomePagePublicApi';
import { api } from '../base';

const baseRoute: string = 'RegistrationPublic';

export class HomePagePublicApi extends IHomePagePublicApi {

  registerDemoinfoPublic(
    request: DemoInfoPublicRequest
  ): Promise<AxiosResponse<Result<string>>> {
    return api.post(`${baseRoute}/registerdemoinfo_public`, request);
  }
}

